import styled from 'styled-components';

export const FaqsSection = styled.section`
  position: relative;
`;
export const FaqsBreadCrumbWrapper = styled.div`
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #fff;
  @media (max-width: 992px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;
export const FaqsBreadCrumbContainer = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  @media (max-width: 1200px) {
    max-width: 1100px;
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 992px) {
    max-width: 960px;
  }
  @media (max-width: 768px) {
    max-width: 720px;
  }
  @media (max-width: 576px) {
    max-width: 540px;
  }
`;
export const FaqsBreadCrumbRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 992px) {
    flex-direction: column;
    align-items: start;
  }
`;
export const FaqsBreadCrumbText = styled.h2`
  font-size: 30px;
  line-height: 42px;
  font-weight: 400;
  color: #000000;
  max-width: 870px;
  margin: 0px;
  &[dir='ltr'] {
    text-align: left;
  }
  &[dir='rtl'] {
    text-align: right;
  }
  @media (max-width: 1600px) {
    font-size: 30px;
  }
  @media (max-width: 1435px) {
    font-size: 30px;
    line-height: 42px;
  }
  @media (max-width: 1270px) {
    max-width: 600px;
    font-size: 24px;
    line-height: 35px;
  }
  @media (max-width: 992px) {
    max-width: 100%;
    font-size: 20px;
    line-height: 32px;
  }
`;
export const FaqsBreadCrumbTextButton = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 270px;
  @media (max-width: 1435px) {
    max-width: 475px;
  }
  @media (max-width: 992px) {
    max-width: 100%;
    padding-top: 20px;
    flex-wrap: wrap;
    width: 100%;
  }
  p {
    font-size: 16px;
    line-height: 16px;
    color: #575757;
    margin: 0px;
    @media (max-width: 1600px) {
      font-size: 16px;
      line-height: 16px;
    }
    @media (max-width: 1270px) {
      font-size: 13px;
    }
    @media (max-width: 992px) {
      font-size: 16px;
    }
    @media (max-width: 576px) {
      padding-bottom: 5px;
    }
  }
  &[dir='ltr'] {
    letter-spacing: 1.26px;
  }
`;
export const FaqsDesktopWrapper = styled.div`
  background-color: #f2f2f2;
  width: 100%;
  @media (min-width: 767px) {
    display: block;
  }
  display: none;
`;
export const FaqsMobileWrapper = styled.div`
  background-color: #f2f2f2;
  width: 100%;
  @media (min-width: 767px) {
    display: none;
  }
  display: block;
`;
export const FaqsContainer = styled.div`
  padding-top: 100px;
  padding-bottom: 70px;
  width: 1696px;
  margin: 0px auto;
  @media (max-width: 1910px) {
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
  }
  @media (max-width: 992px) {
    padding-top: 50px;
    padding-bottom: 35px;
  }
`;
export const FaqsCardsWrapper = styled.div`
  padding-bottom: 30px;
  @media (max-width: 1600px) {
    padding-bottom: 15px;
  }
`;
export const FaqsCards = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 30px;
  column-gap: 30px;
  @media (max-width: 1600px) {
    column-gap: 15px;
  }
`;
export const FaqsCard = styled.button`
  width: calc(20% - 24px);
  min-height: 190px;
  outline: none;
  border: none;
  background: #fff;
  cursor: pointer;
  padding-top: 42px;
  padding-bottom: 42px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  @media (max-width: 1600px) {
    width: calc(20% - 12px);
  }
  svg {
    height: 56px;
    @media (max-width: 1024px) {
      height: 37px;
    }
    fill: #3b79d6;
    &.venue-services-for-exhibitions {
      fill: #fff;
    }
  }
  &.active-card {
    background: #3b79d6;
    opacity: 1 !important;
    svg {
      fill: #fff;
      path {
        fill: #fff;
      }
    }
  }
  &.card-opacity {
    opacity: 0.5;
  }
  @media (max-width: 1200px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  @media (max-width: 992px) {
    min-height: 170px;
    padding-left: 10px;
    padding-right: 10px;
  }
  @media (max-width: 767px) {
    width: calc(50% - 12px);
    padding-top: 20px;
    padding-bottom: 20px;
    justify-content: center;
    min-height: 120px;
    span {
      display: flex !important;
      justify-content: center;
      align-items: center;
      img {
        width: 70%;
        height: auto;
        object-fit: contain;
      }
    }
    svg {
      width: 45px;
      height: 45px;
    }
  }
`;
export const FaqsTitle = styled.h5`
  font-size: 18px;
  margin: 0px;
  color: #3b79d6;
  font-weight: 400;
  line-height: 1;
  letter-spacing: -0.36px;
  padding-top: 32px;
  &[dir='ltr'] {
    font-family: DINRegular;
  }
  &[dir='rtl'] {
    font-family: GESSTwoDWTCLight, sans-serif;
  }
  &.active-title {
    color: #fff;
  }
  @media (max-width: 1300px) {
    padding-top: 40px;
  }
  @media (max-width: 992px) {
    padding-top: 15px;
    font-size: 16px;
  }
  @media (max-width: 767px) {
    padding-top: 12px;
    font-size: 12px;
    line-height: 1;
    min-height: 0px;
    letter-spacing: 0.24px;
    min-height: 36px;
  }
`;
export const FaqsDescription = styled.p`
  font-size: 16px;
  line-height: 22px;
  margin: 0px;
  color: #575757;
  padding-top: 18px;
  &[dir='ltr'] {
    font-family: 'DINRegular';
  }
  &[dir='rlt'] {
    font-family: GESSTwoDWTCLight, sans-serif;
  }
  @media (max-width: 992px) {
    font-size: 14px;
    padding-top: 10px;
    line-height: 22px;
  }
  @media (max-width: 767px) {
    font-size: 12px;
    padding-top: 5px;
    line-height: 18px;
  }
  &.active-description {
    color: #fff;
  }
`;
export const FaqsQuestionAnswerWrapper = styled.div`
  margin-top: 30px;
  padding-top: 48px;
  padding-bottom: 8px;
  background: #fff;
  padding-left: 40px;
  padding-right: 112px;
  position: relative;
  @media (max-width: 1600px) {
    padding-right: 20px;
    padding-left: 20px;
  }
  @media (max-width: 992px) {
    padding-top: 25px;
  }
  @media (max-width: 767px) {
    margin-top: 20px;
    padding-top: 37px;
    padding-bottom: 8px;
    padding-left: 24px;
    padding-right: 24px;
  }
  &[dir='ltr'] {
    button {
      right: 24px;
      @media (max-width: 767px) {
        right: 16px;
      }
    }
  }
  &[dir='rtl'] {
    button {
      left: 24px;
      @media (max-width: 767px) {
        left: 16px;
      }
    }
  }
  button {
    top: 24px;
    position: absolute;
    cursor: pointer;
    background-color: #fff;
    border: none;
    outline: none;
    padding: 0px;
    @media (max-width: 767px) {
      svg {
        width: 24px;
        height: 24px;
      }
      top: 12px;
    }
  }
`;
export const FaqsQuestionAnswer = styled.div`
  padding-bottom: 42px;
  @media (max-width: 992px) {
    padding-bottom: 25px;
    padding-bottom: 20px;
  }
`;
export const FaqsQuestion = styled.h2`
  line-height: 22px;
  font-size: 22px;
  margin: 0px;
  color: #000000;
  font-weight: 400;
  @media (max-width: 992px) {
    line-height: 22px;
    font-size: 18px;
  }
  @media (max-width: 768px) {
    line-height: 26px;
    font-size: 16px;
  }
`;
export const FaqsAnswer = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin: 0px;
  color: #898989;
  padding-top: 30px;
  @media (max-width: 992px) {
    padding-top: 10px;
  }
  a {
    color: #000;
    text-decoration: underline;
  }
  p {
    color: #898989;
    margin: 0px;
  }
  ol {
    margin: 0px;
  }
`;
